module.exports = __webpack_public_path__ + "static/img/图片12.5fa697f2.png";